var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2878_7618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1135 11.9175L18.531 17.5L24.1135 23.0825L23.0825 24.1135L17.5 18.531L11.9175 24.1135L10.8865 23.0825L16.469 17.5L10.8865 11.9175L11.9175 10.8865L17.5 16.469L23.0825 10.8865L24.1135 11.9175ZM35 17.5C35 27.1498 27.1498 35 17.5 35C7.85021 35 0 27.1498 0 17.5C0 7.85021 7.85021 0 17.5 0C27.1498 0 35 7.85021 35 17.5ZM33.5417 17.5C33.5417 8.65521 26.3448 1.45833 17.5 1.45833C8.65521 1.45833 1.45833 8.65521 1.45833 17.5C1.45833 26.3448 8.65521 33.5417 17.5 33.5417C26.3448 33.5417 33.5417 26.3448 33.5417 17.5Z",
    fill: "#91BCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2878_7618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.643418ade372b5c09e4fb117984d1601.svg";
export { ForwardRef as ReactComponent };